import { FunctionComponent, useCallback, useState } from "react";
import "./TOSFooter.css";
// Make sure this path points to the modal file we created.


// -------------------------
// Modal Hook
// -------------------------
export function useDiagnosticModal() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return { isOpen, open, close };
}


// -------------------------
// Footer
// -------------------------
const CSMFooter: FunctionComponent = () => {

  const {
    isOpen: isDiagnosticOpen,
    open: openDiagnostic,
    close: closeDiagnostic
  } = useDiagnosticModal();

  const onPrivacyTextClick = useCallback(() => {
    window.open("https://www.swagelok.com/en/privacy-policy");
  }, []);

  const onCookiePolicyTextClick = useCallback(() => {
    window.open("https://www.swagelok.com/en/cookie-notice-and-disclosure");
  }, []);

  const onDoNotSellClick = useCallback(() => {
    window.open(
      "https://privacyportal.onetrust.com/webform/2cce8865-122c-4cd9-ba04-145fef276f26/2647cdfd-72ee-42b9-b0b1-2f07da68413c"
    );
  }, []);

  return (
    <>
      <div className="csm-footer">
        <div className="swagelok-company-all-rights-r-parent">
          <div className="swagelok-company-all-container">
            <span className="swagelok-company">© 2026 Swagelok Company.</span>
            <span className="all-rights-reserved">
              {" "}
              All rights reserved. For internal use only.
            </span>
          </div>

          <div className="privacy-policy-links">
            <div className="submit-feedback" onClick={onPrivacyTextClick}>
              Privacy Policy
            </div>
            <div className="div">|</div>

            <div className="submit-feedback" onClick={onCookiePolicyTextClick}>
              Cookie Policy
            </div>
            <div className="div">|</div>

            <div className="submit-feedback" onClick={onDoNotSellClick}>
              Do Not Sell or Share My Personal Information
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CSMFooter;